import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RequireAuth({ children, adminOnly = false, uploaderAllowed = false }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="text-sm text-neutral-500 font-mono-money">loading…</div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    // Round 22 addendum · uploader is confined to /uploader. Every
    // other route in the app redirects to it. Admin-only routes
    // still 403 the uploader on the backend; this redirect is a UX
    // courtesy so they never SEE a 403.
    if (user.role === "uploader" && !uploaderAllowed) {
        return <Navigate to="/uploader" replace />;
    }
    if (adminOnly && user.role !== "admin") return <Navigate to="/employees" replace />;
    return children;
}
